export default class FvsServiceVerificationRequestSessionStorage
  save_request: ->
    request =
      construction_site_id: ''
      all_fvs_period:       'false'
      hide_inapplicable:    0
      fvs_begin_at:         ''
      fvs_end_at:           ''
      services_ids:         []
      fvs_situations:       []
      places_ids:           []
      responsible_ids:      []
      finishers_ids:        []
      approvers_ids:        []
      siffs_ids:            []
      plannings_ids:        []

    # Busca genericamente por qualquer formulário que contenha campos request[...]
    form_object = @findFormWithRequestFields()

    unless form_object
      console.warn 'Formulário de busca não encontrado'
      return false

    $.each form_object.serializeArray(), (i, field) ->
      regex_is_request = /request/
      return unless regex_is_request.test field.name

      regex_is_array       = /\[]/g
      regex_when_array     = /(request\[)(\w*)(]\[])/g
      regex_when_not_array = /(request\[)(\w*)(])/g

      if regex_is_array.test field.name
        attr = field.name.replace regex_when_array, "$2"
        if typeof request[attr] == 'undefined'
          request[attr] = []
        request[attr].push field.value
      else
        attr = field.name.replace regex_when_not_array, "$2"

        if typeof request[attr] == 'undefined'
          request[attr] = []

        request[attr] = field.value

    sessionStorage.setItem 'request', JSON.stringify request
    return true

  @get_request: ->
    JSON.parse sessionStorage.getItem 'request'

  restore_request: ->
    request = FvsServiceVerificationRequestSessionStorage.get_request()
    return unless request
    
    # Busca genericamente por qualquer formulário que contenha campos request[...]
    form_object = @findFormWithRequestFields()
    return unless form_object

    restored_count = 0
    for key, value of request
      input = form_object.find('[name="request[' + key + ']"]')
      if input.length > 0
        try
          if Array.isArray(value)
            input.val(value)
            input.trigger('change')
          else
            input.val(value)
            input.trigger('change')
          restored_count++
        catch error
          console.warn("Erro ao restaurar campo #{key}:", error)
    
    return restored_count > 0

  # Método para encontrar formulário FVS específico
  findFormWithRequestFields: ->
    $form = $('.fvs-search-form')
    return if $form.length > 0 then $form else null

window.FvsServiceVerificationRequestSessionStorage = FvsServiceVerificationRequestSessionStorage
